/**
 * Public Cloudflare Pages stays synthetic by default.
 *
 * A connected testing build must explicitly enable staging. API calls use
 * /api on the SAME Cloudflare origin, where a fail-closed Pages Function
 * proxies exclusively to a separately configured staging backend.
 *
 * No query parameter, localStorage value, or arbitrary browser input can
 * switch the UI into backend mode.
 */
export const isPagesPreviewHost = () =>
  typeof window !== "undefined" && window.location.hostname.endsWith(".pages.dev");

export const connectedPreviewEnabled =
  process.env.REACT_APP_PREVIEW_DATA_MODE === "staging" &&
  process.env.REACT_APP_CONFIRM_ISOLATED_STAGING === "yes" &&
  process.env.REACT_APP_STAGING_API_PROXY_READY === "yes";

export const previewMode = isPagesPreviewHost()
  ? connectedPreviewEnabled ? "staging" : "demo"
  : "application";
